import "./style.css"
import { generator } from "@/utils/NumbersUtils"
import { useTranslation } from "react-i18next"

const Tabs = ({ List, onApply, className="", activeTab }) => {

    const { t } = useTranslation()

    const handleActiveTab = (id) => {

        onApply(prev => id)
    }

    return (
        <div className={`tabs-container ${className}`}>
            {List?.mapWithKey((item, index) => (
                <div key={item.key} className={`tab ${activeTab == item?.value ? "active-tab" : ""}`} onClick={() => handleActiveTab(item?.value)}>{t(item?.label)}</div>
            ))}
        </div>)
}

export default Tabs